<span class="message">
    <mat-icon *ngIf="data.type === 'error'" color="warn">error</mat-icon>
    <mat-icon *ngIf="data.type === 'warn'">error</mat-icon>
    <mat-icon *ngIf="data.type === 'info'">check_circle</mat-icon>
    <span class="ms-1">{{data.message}}</span>
    <button class="ms-1" (click)="dismiss()" color="accent" *ngIf="!data.showDetails" mat-button>
        {{data.action}}
    </button>

    <button class="ms-1" (click)="showDetails()" color="accent" *ngIf="data.showDetails" mat-button>
        details
    </button>
</span>